import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Form,
  Row,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2";
import DataTable from "react-data-table-component";
import { H3, Btn, Breadcrumbs } from "../../../AbstractElements";
import { Link, useNavigate } from "react-router-dom";
import { getDataWithToken, postDataWithToken } from "../../../Utils/restUtils";
import {
  Add,
  Customer,
  CustomerList,
  changepwd,
  Search,
  Filter,
  Area,
  Status,
  Export,
  Import,
  importFile,
  customerImportTitle,
  customerImportTableTitle,
  customerDueImportTitle,
  AddCustomer,
  AddServiceAccount,
  Enquiry,
  EnquiryList,
  newEnquiry,
  FollowUp,
  overDueFollowUps,
  followUpsList,
  followUps,
} from "../../../Constant";
import {
  followUpStatusChange,
  getStaff,
  showfollowup,
} from "../../../CommonURL";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Popup from "../../Common/Popup/Popup";
// import ChangePwd from './ChangePwd';
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
// import { conditionalRow } from '../../Common/Rowstyle/Rowstyle';
// import Widgets from '../../Common/Progress/Widgets';
import moment from "moment";
import Transparentspinner from "../../Common/loader/Transparentspinner";
// import ImportDuePopUp from '../../Common/Import/ImportDuePop';
// import WidgetSmall from '../../Common/Progress/WidgetSmall';
import { CustomerColumns, followUpColumns } from "../CloumnHeader/Header";

const FollowUps = () => {
  const searchParams = location.search;
  const params = new URLSearchParams(searchParams);
  const [spinnerTrans, setspinnerTrans] = useState(false);
  const [customerLists, setCustomerList] = useState([]);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [tempUser, setTempUser] = useState("");
  const [userData, setUserData] = useState([]);
  const [filters, setFilters] = useState({
    search: "",
    userId: "",
    stage: "",
    start_date: null,
    end_date: null,
  });

  const [tempSearch, setTempSearch] = useState("");
  const [tempStage, setTempStage] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [sortConfig, setSortConfig] = useState({ column: "", order: "" });

  const formatStartDate = filters.start_date
    ? moment(filters.start_date).format("DD-MM-YYYY")
    : "";
  const formatEndDate = filters.end_date
    ? moment(filters.end_date).format("DD-MM-YYYY")
    : "";

  const authState = useSelector((state) => state.auth);

  const navigate = useNavigate();

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };

  const enquiryStatusOptions = [
    { label: "Prospect", value: "prospect" },
    { label: "Negotiation", value: "negotiation" },
    { label: "Won", value: "won" },
    { label: "Lost", value: "lost" },
  ];

  useEffect(() => {
    fetchFollowUps(1);
    getUserData();
  }, []);
  useEffect(() => {
  fetchFollowUps(currentPage, perPage);
}, [sortConfig]);
useEffect(() => {
  fetchFollowUps(1);
}, [filters]);
  const handleSort = (column) => {
    const newOrder =
      sortConfig.column === column.id && sortConfig.order === "asc"
        ? "desc"
        : "asc";

   setSortConfig({
  column: column.id,
  order: newOrder,
});
  };

  const handleApiError = (status) => {
    if (status >= 400 && status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (status >= 500 && status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
  };

  //user data

  const getUserData = async () => {
    const data = await getDataWithToken(getStaff);

    if (data.status === true) {
      setUsers(data.data.data);
    }
  };

  const fetchFollowUps = async (page = currentPage, size = perPage) => {
    setspinnerTrans(true);
  const SerialNo = (page - 1) * size + 1;
    try {
      const response = await getDataWithToken(
        `${showfollowup}?page=${page}
      &page_length=${size}
      &search=${filters.search || ""}
      &start_date=${formatStartDate || ""}
      &end_date=${formatEndDate || ""}
      &user_id=${filters.userId || ""}
      &stage=${filters.stage || ""}
      &sort_by=${sortConfig.column || ""}
      &sort_order=${sortConfig.order || ""}`,
      );

if (response?.status === true) {
  setCustomerList(
    response?.data?.data.map((e, index) => ({
      Si: SerialNo + index,
      name: e.name || "N/A",
      leadId: e?.lead || "N/A",
      id:e?.id || "N/A",
      remarks: e.remarks || "N/A",
      assigned: e?.assigned_to || "N/A",
      nextFolloWDate: e?.next_followup_date || "N/A",
      created_at: e?.created_at || "N/A",
      lead_id: e?.lead_id|| "N/A",
      stage: e?.stage || "N/A",
      status: e?.status || "N/A",
    }))
  );

  setTotalRows(response.data.total || response.data.data.length);
}
    } finally {
      setspinnerTrans(false);
    }
  };

 const exportCustomerExcel = async () => {
  setspinnerTrans(true);

  try {
    const response = await getDataWithToken(
      `${showfollowup}?page=1
      &page_length=10000
      &search=${filters.search || ""}
      &start_date=${formatStartDate || ""}
      &end_date=${formatEndDate || ""}
      &user_id=${filters.userId || ""}
      &stage=${filters.stage || ""}
      &sort_by=${sortConfig.column || ""}
      &sort_order=${sortConfig.order || ""}`
    );

    if (response?.status === true) {
      const dataToExport = response.data.data.map((item) => ({
        Lead_ID: item.lead || "",
        Name: item.name || "",
        Assigned_To: item.assigned_to || "",
        Remarks: item.remarks || "",
        Next_Followup_Date: item.next_followup_date || "",
        Created_At: item.created_at || "",
        Stage: item.stage || "",
      }));

      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, "FollowUps");
      XLSX.writeFile(wb, "followup_report.xlsx");
    }
  } catch (error) {
    console.log("Excel Export Error:", error);
    toast.error("Failed to export Excel");
  } finally {
    setspinnerTrans(false);
  }
};

const exportCustomerPdf = async () => {
  setspinnerTrans(true);

  try {
    const response = await getDataWithToken(
      `${showfollowup}?page=1
      &page_length=10000
      &search=${filters.search || ""}
      &start_date=${formatStartDate || ""}
      &end_date=${formatEndDate || ""}
      &user_id=${filters.userId || ""}
      &stage=${filters.stage || ""}
      &sort_by=${sortConfig.column || ""}
      &sort_order=${sortConfig.order || ""}`
    );

    if (response?.status === true) {
      const rows = response.data.data.map((item, index) => [
        index + 1,
        item.lead || "",
        item.name || "",
        item.assigned_to || "",
        item.remarks || "",
        item.next_followup_date || "",
        item.created_at || "",
        item.stage || "",
      ]);

      const doc = new jsPDF("landscape");

      doc.setFontSize(16);
      doc.text("Follow Up Report", 14, 15);

      autoTable(doc, {
        startY: 25,
        head: [[
          "Sl",
          "Lead ID",
          "Name",
          "Assigned To",
          "Remarks",
          "Next Followup Date",
          "Created At",
          "Stage",
        ]],
        body: rows,
        styles: {
          fontSize: 8,
        },
        headStyles: {
          fillColor: [41, 128, 185],
        },
      });

      doc.save("followup_report.pdf");
    }
  } catch (error) {
    console.log("PDF Export Error:", error);
    toast.error("Failed to export PDF");
  } finally {
    setspinnerTrans(false);
  }
};

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchFollowUps(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchFollowUps(page, newPerPage);
  };

const handleFilter = (e) => {
  e.preventDefault();

  setFilters({
    search: tempSearch,
    userId: tempUser,
    stage: tempStage,
    start_date: startDate,
    end_date: endDate,
  });

  setCurrentPage(1);
};

  const Action = ({ row }) => {
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleStatusUpdate = async (status) => {
      setspinnerTrans(true);
      const postRequest = {
        status: status,
        followup_id: row.id,
      };
      
      const response = await postDataWithToken(
        followUpStatusChange,
        postRequest,
      );

      if (response.status === 200) {
        toast.success(response.data.message);
        fetchFollowUps(1);
      } else if (response.status >= 400 && response.status <= 405) {
        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
      } else if (response.status >= 500 && response.status <= 505) {
        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
      } else {
        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
      }

      setspinnerTrans(false);
    };

    return (
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle
          color="#00000"
          style={{ fontSize: "14px", zIndex: 1000 }}
        >
          <i className="fa fa-ellipsis-v"></i>
        </DropdownToggle>
        <DropdownMenu container="body">
          {row.status === "done" ? (
            <DropdownItem
              style={toggleStyle}
              onClick={() => handleStatusUpdate("pending")}
            >
              Pending
            </DropdownItem>
          ) : (
            <DropdownItem
              style={toggleStyle}
              onClick={() => handleStatusUpdate("done")}
            >
              Done
            </DropdownItem>
          )}
          {/* }  */}
        </DropdownMenu>
      </Dropdown>
    );
  };

  return (
    <>
      {spinnerTrans && <Transparentspinner />}
      <Breadcrumbs
        mainTitle="follow-Ups"
        parent="Lead Manager"
        title="follow-Ups List"
      />
      <Card className="cardWidth mt-4">
        <CardHeader
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <H3>Follow-Ups List</H3>
          <Dropdown
            className="m-0"
            isOpen={dropdownOpen}
            toggle={toggleDropdown}
          >
            <DropdownToggle
              color="#fff"
              style={{ fontSize: "14px", zIndex: 1000 }}
              className="btn btn-primary mr-4"
            >
              {Export} <i className="icofont icofont-arrow-up"></i>
            </DropdownToggle>
            <DropdownMenu container="body">
              <DropdownItem
                style={toggleStyle}
                onClick={() => exportCustomerExcel()}
              >
                <i className="fa fa-file-excel-o me-2"></i> Excel
              </DropdownItem>
              <DropdownItem
                style={toggleStyle}
                onClick={() => exportCustomerPdf()}
              >
                <i className="fa fa-file-pdf-o me-2"></i> Pdf
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </CardHeader>
        <CardBody>
          <span className="">
            <Form
              className="needs-validation"
              noValidate
              onSubmit={handleFilter}
            >
              <Row className="ps-3 gap-sm-3 gap-md-2 mb-4 filterGap">
                <Col sm="12" md="5" lg="2">
                  <input
                    className="form-control"
                    value={tempSearch}
                    onChange={(e) => setTempSearch(e.target.value)}
                    placeholder={Search}
                  />
                </Col>

                <Col sm="12" md="5" lg='3' className="form-element" >
                  <div style={{ position: 'relative', zIndex: 2 }}>
                    <DatePicker
                      className="form-control digits w-100"
                      selectsRange
                      startDate={startDate}
                      endDate={endDate}
                      onChange={(update) => {
                        setDateRange(update);
                      }}
                      isClearable={startDate ? true : false}
                      monthsShown={2}
                      dateFormat="dd/MM/yyyy"
                      popperPlacement="bottom"
                      calendarClassName='parallel-calendar'
                      placeholderText='Select Date Range'
                    />
                  </div>
                </Col>
                <Col sm="12" md="2">
                  <select
                    value={tempUser}
                    onChange={(e) => setTempUser(e.target.value)}
                    className="form-control"
                  >
                    <option value="">Assigned User</option>

                    {users?.map((item) => (
                      <option
                        key={item.user_id || item.id}
                        value={item.user_id || item.id}
                      >
                        {item.first_name}
                      </option>
                    ))}
                  </select>
                </Col>
                <Col sm="12" md="5" lg="2" className="form-element">
                  <div style={{ position: "relative", zIndex: 2 }}>
                    <select
                      value={tempStage}
                      onChange={(e) => setTempStage(e.target.value)}
                      className="form-select"
                    >
                      <option value={""}> Stage</option>
                      {enquiryStatusOptions?.map((item) => (
                        <option key={item?.value} value={item?.value}>
                          {item?.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
                <Col sm="12" md="5" lg="1" className="custom-filtrs">
                  <Btn attrBtn={{ color: "primary" }} type="submit">
                    {Filter}
                  </Btn>
                </Col>
              </Row>
            </Form>
          </span>

          <div className="order-history table-responsive">
            <DataTable
              columns={followUpColumns(authState, Action)}
              data={customerLists}
              // progressPending={loading}
              pagination
              paginationServer
              defaultSortAsc
              onSort={handleSort}
              sortServer
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              //   conditionalRowStyles={conditionalRow}
              onChangePage={handlePageChange}
            />
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default FollowUps;
